module.exports = __webpack_public_path__ + "img/lucasi1.png";